import React, { Fragment, useState } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { reduxForm, Field, formValueSelector } from 'redux-form';

import IconButton from 'material-ui/IconButton';
import CreateIcon from 'material-ui/svg-icons/content/create';

import FlatButton from 'material-ui/FlatButton';
import RaisedButton from 'material-ui/RaisedButton';
import Dialog from 'material-ui/Dialog';
import MenuItem from 'material-ui/MenuItem';

import { required, length } from 'redux-form-validators';

import { SelectField, TextField } from 'redux-form-material-ui';

import { changePort } from 'actions/regions/ports';

import gmtData from 'data/gmt';

import { formName } from 'data/formNames';
import AltNames from './AltNames';

const styles = {
    dialog: {
        contentStyle: { width: '300px', padding: '18px' },
    },
    textField: {
        floatingLabelStyle: { fontSize: '12px' },
    },
    icon: { color: '#CBCBCB' },
};

const Sidebar = (props) => {
    const { 
        port, 
        countries,
        handleSubmit, 
        change, 
        changePort, 
    } = props;

    const [openDialog, setOpenDialog] = useState(false);

    const handleOpenDialog = () => {
        setOpenDialog(true);
    };

    const handleCloseDialog = () => {
        setOpenDialog(false);
    };

    return (
        <Fragment>
            <Dialog
                modal={false}
                open={openDialog}
                contentStyle={styles.dialog.contentStyle}
                onRequestClose={handleCloseDialog}
            >
                <form>
                    <Field
                        component={TextField}
                        name="name"
                        floatingLabelText='Name'
                        floatingLabelStyle={styles.textField.floatingLabelStyle}
                        validate={[required(), length({ min: 3 })]}
                        fullWidth
                    />

                    <Field
                        component={SelectField}
                        name="country._id"
                        floatingLabelText='Country'
                        floatingLabelStyle={styles.textField.floatingLabelStyle}
                        autoWidth
                        validate={required()}
                        onChange={(e, value) => {
                            e.preventDefault();
                            change('country', countries.find(country => country._id === value));
                        }}
                        fullWidth
                    >
                        {
                            countries.map((country, key) => (
                                <MenuItem
                                    key={key}
                                    value={country._id}
                                    primaryText={country.name}
                                />
                            ))
                        }
                    </Field>

                    <Field
                        component={TextField}
                        name="unLoCode"
                        floatingLabelText='UN LOCODE'
                        floatingLabelStyle={styles.textField.floatingLabelStyle}
                        fullWidth
                        validate={[length({ max: 5 })]}
                    />

                    <Field
                        component={SelectField}
                        name="timezone"
                        floatingLabelText='timezone'
                        floatingLabelStyle={styles.textField.floatingLabelStyle}
                        fullWidth
                    >
                        {
                            gmtData.map((gmt, key) => (
                                <MenuItem key={key} value={gmt} primaryText={gmt} />
                            ))
                        }
                    </Field>

                    <Field
                        component={TextField}
                        name="site"
                        floatingLabelText='Web site'
                        floatingLabelStyle={styles.textField.floatingLabelStyle}
                        fullWidth
                        validate={[length({ min: 8, allowBlank: true })]}
                    />

                    <div style={{ display: 'flex' }} className='between-xs'>
                        <FlatButton
                            label="Cancel"
                            onClick={handleCloseDialog}
                            secondary
                        />
                        <RaisedButton
                            label="Save"
                            style={{ background: '#7FC931' }}
                            primary
                            onClick={handleSubmit((submit) => {
                                handleCloseDialog();
                                changePort(submit);
                            })}
                        />
                    </div>
                </form>
            </Dialog>

            <div className="col-lg-3 col-xs-3 sidebar">
                <Field
                    component={({
                        input, label, type, port, meta: { touched, error }, 
                    }) => (
                        <div className={error ? 'validate-error name' : 'name'}>
                            {`${port.name} ${error || ''}`}
                        </div>
                    )}
                    name="name"
                    props={{ port }}
                />

                <Field
                    component={({
                        input, label, type, port, meta: { touched, error }, 
                    }) => (
                        <div className={error ? 'validate-error name country' : 'name country'}>
                            {`${port.country ? port.country.name : ''} ${error || ''}`}
                        </div>
                    )}
                    name="country.name"
                    props={{ port }}
                />

                <div className="divider" />

                <div className='info'>
                    <Field
                        component={({
                            input, label, type, port, meta: { touched, error }, 
                        }) => (
                            <div className={error ? 'validate-error info__title' : 'info__title'}>
                                <span>UN LOCODE: </span> {`${port.unLoCode} ${error || ''}`}
                            </div>
                        )}
                        name="unLoCode"
                        props={{ port }}
                    />

                    <Field
                        component={({
                            input, label, type, port, meta: { touched, error }, 
                        }) => (
                            <div className={error ? 'validate-error info__title' : 'info__title'}>
                                <span>Time Zone:</span>  {`${port.timezone} ${error || ''}`}
                            </div>
                        )}
                        name="timezone"
                        props={{ port }}
                    />

                    <Field
                        component={({
                            input, label, type, port, meta: { touched, error }, 
                        }) => (
                            <a className={error ? 'validate-error info__website' : 'info__website'}>
                                {`${port.site ? port.site : ''} ${error || ''}`}
                            </a>
                        )}
                        name="site"
                        props={{ port }}
                    />

                    <div className="info__change">
                        <IconButton
                            iconStyle={styles.icon}
                            onClick={handleOpenDialog}
                        >
                            <CreateIcon
                                style={styles.icon}
                            />
                        </IconButton>
                    </div>
                    <AltNames
                        port={port}
                        onEditAltNames={handleOpenDialog}
                    />
                </div>
            </div>
        </Fragment>
    );
};

Sidebar.propTypes = {
    port: PropTypes.object,
    countries: PropTypes.array,
    handleSubmit: PropTypes.func,
    change: PropTypes.func,
    changePort: PropTypes.func,
};

Sidebar.defaultProps = {
    port: {},
    countries: [],
};

const MyForm = reduxForm({
    form: formName.portUpdate,
    enableReinitialize: true,
    destroyOnUnmount: false,
    keepDirtyOnReinitialize: true,
})(Sidebar);

const selector = formValueSelector(formName.portUpdate);
export default connect(
    state => ({
        countries: state.countries.items,
        initialValues: { ...state.port },
        port: selector(state, 'name', 'timezone', 'country', 'unLoCode', 'site', 'alt'),
    }),
    dispatch => bindActionCreators({
        changePort,
    }, dispatch),
)(MyForm);



// WEBPACK FOOTER //
// ./app/components/Regions/Port/Sidebar.jsx